<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>關於商家</f7-nav-title>
    </f7-navbar>
    <f7-block inner v-if="store">
      <p>
        {{ fullStoreName }}<br>
        電話: {{ store.storePhoneNumber }}<br>
        地址: {{ store.address }}<br>
        Email: {{ store.email }}
      </p>
      <pre>{{ store.description }}</pre>
    </f7-block>
  </f7-page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState(['store']),
    ...mapGetters(['fullStoreName'])
  }
}
</script>
